import { FC, useEffect, useRef, useState } from 'react';
import BrandLogo from './BrandLogo';
import { Modal } from '@mui/material';
import axios from 'axios';
import "../../index.css"
import { useLandingStyles, PRELOADER_FALLBACK_STYLE } from './landingStyles';
import SigninForm from './SigninForm';

import BgImg from './images/header/banner-bg.svg';
import BgImg2 from './images/bg2.png';
import Img0 from './images/icon.png';
import Img1 from './images/wareozo-light.png';
import Img01 from './images/wareozo.png';
import SignUpForm from '../SignUp/SignUpForm';
import ForgotPassword from '../ForgotPassword/ForgotPassword';

const OptOutForm: FC = () => {
  const [open, setOpen] = useState(false);
  const [loading] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [menu, setMenu] = useState(false);
  const [type, setType] = useState('0');
  const [submitted, setSubmitted] = useState(false);

  const navRef = useRef<any>();
  const [width, setWidth] = useState<number>(window.innerWidth);

  const [formData, setFormData] = useState({
    phone: '',
    countryCode: '+91',
    email: '',
    whatsapp: false,
    email_channel: false,
    sms: false,
    optOutAll: false,
    reason: '',
  });

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  // Landing chrome (bootstrap + marketing theme + Muli form theme) is global
  // CSS; keep it alive only while this page is mounted.
  const stylesReady = useLandingStyles();

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const { offsetTop } = navRef.current;
      if (window.pageYOffset > offsetTop) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const isMobile = width <= 768;


  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const target = e.target as HTMLInputElement;
    const { name, value, type } = target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? target.checked : value
    }));
  };

  const handleOptOutAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setFormData(prev => ({
      ...prev,
      optOutAll: checked,
      whatsapp: checked,
      email_channel: checked,
      sms: checked,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.phone && !formData.email) {
      alert('Please provide either your phone number or email address so we can identify your account.');
      return;
    }

    if (!formData.whatsapp && !formData.email_channel && !formData.sms) {
      alert('Please select at least one channel to opt out from.');
      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}api/v1/consent/opt-out`, {
        phone: formData.phone,
        countryCode: formData.countryCode,
        email: formData.email,
        channels: {
          whatsapp: formData.whatsapp,
          email: formData.email_channel,
          sms: formData.sms,
        },
        reason: formData.reason,
      });
      setSubmitted(true);
    } catch (err: any) {
      const message = err?.response?.data?.message || 'Something went wrong. Please try again.';
      alert(message);
    }
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '10px 14px',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.2s',
  };

  const labelStyle: React.CSSProperties = {
    display: 'block',
    marginBottom: '6px',
    fontWeight: 600,
    fontSize: '14px',
    color: '#374151',
  };

  const checkboxLabelStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    color: '#374151',
    cursor: 'pointer',
  };

  return (
    <>
      {(loading || !stylesReady) && <div className="preloader" style={PRELOADER_FALLBACK_STYLE}>
        <div className="loader">
          <div className="spinner">
            <div className="spinner-container">
              <div className="spinner-rotator">
                <div className="spinner-left">
                  <div className="spinner-circle"></div>
                </div>
                <div className="spinner-right">
                  <div className="spinner-circle"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}

      <header className="header-area" style={{marginTop: '-64px'}}>
        <div ref={navRef} className={`navbar-area navbar-tight ${scrolled ? 'sticky' : ''}`}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <nav className="navbar navbar-expand-lg">
                  <a className="navbar-brand" href="/signin">
                    <BrandLogo isMobile={isMobile} onDark={!scrolled} />
                  </a>
                  <button
                    className={`navbar-toggler ${menu && 'active'}`}
                    type="button"
                    onClick={() => setMenu(!menu)}
                  >
                    <span className="toggler-icon"> </span>
                    <span className="toggler-icon"> </span>
                    <span className="toggler-icon"> </span>
                  </button>

                  <div className={`collapse navbar-collapse sub-menu-bar ${menu && 'show'}`}>
                    <ul id="nav" className="navbar-nav ms-auto">
                      <li className="nav-item" onClick={() => setMenu(false)}>
                        <a className="page-scroll" href="/signin#home">Home</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(false)}>
                        <a className="page-scroll" href="/signin#features">Features</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(false)}>
                        <a className="page-scroll" href="/signin#pricing">Pricing</a>
                      </li>
                      <li className="nav-item" onClick={() => setMenu(false)}>
                        <a className="page-scroll" href="/signin#about">About</a>
                      </li>
                    </ul>
                  </div>

                  <div className="navbar-btn d-none d-sm-inline-block">
                    <a
                      className="main-btn"
                      style={{ backgroundColor: scrolled ? '#059669' : '#fff', color: scrolled ? '#fff' : '#059669', border: '2px solid #059669', textDecoration: 'none' }}
                      onClick={() => setOpen(!open)}
                      rel="nofollow"
                    >
                      Login Now
                    </a>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div
          id="home"
          className="header-hero bg_cover"
          style={{ backgroundImage: `url(${BgImg})` }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="header-hero-content text-center">
                  <h2
                    className="header-title wow fadeInUp"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.5s"
                  >
                    Communication Opt-Out
                  </h2>
                </div>
              </div>
            </div>
            <div style={{ height: 300 }}></div>
          </div>
          <div id="particles-1" className="particles"></div>
        </div>
      </header>

      <section>
        <div style={{padding: '0 10%'}}>
          <div style={{ maxWidth: '700px', margin: '40px auto' }}>
            {submitted ? (
              <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>&#10003;</div>
                <h3 style={{ color: '#059669', marginBottom: '12px' }}>Opt-Out Request Submitted</h3>
                <p style={{ color: '#6b7280', fontSize: '15px' }}>
                  Your request has been received. We will process your opt-out within <strong>48 hours</strong>.
                  You will no longer receive communications on the channels you selected.
                </p>
                <p style={{ color: '#6b7280', fontSize: '14px', marginTop: '16px' }}>
                  If you change your mind, you can re-subscribe anytime via our <a href="/opt-in" style={{ color: '#059669' }}>Opt-In page</a>.
                </p>
              </div>
            ) : (
              <>
                <p style={{ color: '#6b7280', fontSize: '15px', marginBottom: '10px' }}>
                  Use this form to withdraw your consent and stop receiving communications from Wareozo or businesses using our platform.
                  You can choose to opt out from specific channels or all channels at once.
                </p>
                <p style={{ color: '#6b7280', fontSize: '13px', marginBottom: '30px' }}>
                  You can also opt out by replying <strong>STOP</strong> to any WhatsApp message or by emailing <a href="mailto:support@wareozo.com" style={{ color: '#059669' }}>support@wareozo.com</a>.
                </p>

                <form onSubmit={handleSubmit}>
                  <div style={{ marginBottom: '20px', padding: '16px', backgroundColor: '#fef3c7', borderRadius: '10px', border: '1px solid #fcd34d' }}>
                    <p style={{ fontSize: '13px', color: '#92400e', margin: 0 }}>
                      Please provide either your phone number or email address (or both) so we can identify your account and process the opt-out.
                    </p>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '120px 1fr', gap: '10px', marginBottom: '20px' }}>
                    <div>
                      <label style={labelStyle}>Code</label>
                      <select name="countryCode" value={formData.countryCode} onChange={handleChange} style={{...inputStyle, cursor: 'pointer'}}>
                        <option value="+91">+91 (IN)</option>
                        <option value="+1">+1 (US)</option>
                        <option value="+44">+44 (UK)</option>
                        <option value="+971">+971 (UAE)</option>
                        <option value="+61">+61 (AU)</option>
                        <option value="+65">+65 (SG)</option>
                      </select>
                    </div>
                    <div>
                      <label style={labelStyle}>Phone Number</label>
                      <input type="tel" name="phone" value={formData.phone} onChange={handleChange} style={inputStyle} placeholder="Enter phone number" />
                    </div>
                  </div>

                  <div style={{ marginBottom: '24px' }}>
                    <label style={labelStyle}>Email Address</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} style={inputStyle} placeholder="Enter email address" />
                  </div>

                  <div style={{ marginBottom: '24px', padding: '20px', backgroundColor: '#f9fafb', borderRadius: '10px', border: '1px solid #e5e7eb' }}>
                    <label style={{...labelStyle, marginBottom: '12px', fontSize: '15px'}}>Opt Out From <span style={{color: 'red'}}>*</span></label>
                    <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '12px' }}>Select the channels you want to unsubscribe from:</p>

                    <div style={{ marginBottom: '12px', paddingBottom: '12px', borderBottom: '1px solid #e5e7eb' }}>
                      <label style={{...checkboxLabelStyle, fontWeight: 600}}>
                        <input type="checkbox" name="optOutAll" checked={formData.optOutAll} onChange={handleOptOutAll} style={{ width: '16px', height: '16px', accentColor: '#dc2626' }} />
                        Opt out from ALL channels
                      </label>
                    </div>

                    <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '16px' }}>
                      <label style={checkboxLabelStyle}>
                        <input type="checkbox" name="whatsapp" checked={formData.whatsapp} onChange={handleChange} style={{ width: '16px', height: '16px', accentColor: '#dc2626' }} />
                        WhatsApp
                      </label>
                      <label style={checkboxLabelStyle}>
                        <input type="checkbox" name="email_channel" checked={formData.email_channel} onChange={handleChange} style={{ width: '16px', height: '16px', accentColor: '#dc2626' }} />
                        Email
                      </label>
                      <label style={checkboxLabelStyle}>
                        <input type="checkbox" name="sms" checked={formData.sms} onChange={handleChange} style={{ width: '16px', height: '16px', accentColor: '#dc2626' }} />
                        SMS
                      </label>
                    </div>
                  </div>

                  <div style={{ marginBottom: '30px' }}>
                    <label style={labelStyle}>Reason for Opt-Out <span style={{ fontSize: '12px', color: '#9ca3af', fontWeight: 400 }}>(Optional)</span></label>
                    <select name="reason" value={formData.reason} onChange={handleChange} style={{...inputStyle, cursor: 'pointer'}}>
                      <option value="">Select a reason</option>
                      <option value="too_frequent">Messages are too frequent</option>
                      <option value="not_relevant">Messages are not relevant to me</option>
                      <option value="no_longer_customer">I am no longer a customer</option>
                      <option value="did_not_subscribe">I did not subscribe to these messages</option>
                      <option value="privacy_concerns">Privacy concerns</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <button
                    type="submit"
                    style={{
                      width: '100%',
                      padding: '14px',
                      backgroundColor: '#dc2626',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: 600,
                      cursor: 'pointer',
                      transition: 'background-color 0.2s',
                    }}
                  >
                    Submit Opt-Out Request
                  </button>

                  <p style={{ textAlign: 'center', marginTop: '16px', fontSize: '13px', color: '#9ca3af' }}>
                    Your request will be processed within 48 hours. For immediate assistance, email <a href="mailto:support@wareozo.com" style={{ color: '#059669' }}>support@wareozo.com</a>.
                  </p>
                </form>
              </>
            )}
          </div>
        </div>
      </section>

      <footer id="footer" className="footer-area pt-120">
        <div className="container">
          <div className="subscribe-area wow fadeIn" data-wow-duration="1s" data-wow-delay="0.5s">
            <div className="row align-items-center">
              <div className="col-lg-8">
                <div className="subscribe-content mt-45">
                  <h2 className="subscribe-title">Stay Connected <span>subscribe to our communication channels</span></h2>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="mt-45" style={{ textAlign: 'right' }}>
                  <a href="/opt-in" style={{ textDecoration: 'none', padding: '12px 36px', borderRadius: '30px', backgroundColor: '#059669', color: '#fff', fontSize: '16px', fontWeight: 600, display: 'inline-block' }}>Subscribe Now</a>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-widget pb-100">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-8">
                <div className="footer-about mt-50 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s">
                  <a className="logo" href="javascript:void(0)">
                    <BrandLogo isMobile={isMobile} onDark />
                  </a>
                  <p className="text">Simplify invoicing, automate accounting, and boost business growth with smart, secure, and efficient wareozo billing software.</p>
                  <ul className="social">
                    <li><a href="javascript:void(0)"><i className="lni lni-facebook-filled"> </i></a></li>
                    <li><a href="javascript:void(0)"><i className="lni lni-twitter-filled"> </i></a></li>
                    <li><a href="javascript:void(0)"><i className="lni lni-instagram-filled"> </i></a></li>
                    <li><a href="javascript:void(0)"><i className="lni lni-linkedin-original"> </i></a></li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-5 col-md-7 col-sm-12">
                <div className="footer-link d-flex mt-50 justify-content-sm-between">
                  <div className="link-wrapper wow fadeIn" data-wow-duration="1s" data-wow-delay="0.4s">
                    <div className="footer-title"><h4 className="title">Quick Link</h4></div>
                    <ul className="link">
                      <li><a href="/privacy-policy">Privacy Policy</a></li>
                      <li><a href="/terms-of-use">Terms of Service</a></li>
                      <li><a href="/signin#pricing">Pricing</a></li>
                      <li><a href="/signin#faq">FAQ</a></li>
                      <li><a href="/opt-out">Unsubscribe</a></li>
                    </ul>
                  </div>
                  <div className="link-wrapper wow fadeIn" data-wow-duration="1s" data-wow-delay="0.6s">
                    <div className="footer-title"><h4 className="title">Resources</h4></div>
                    <ul className="link">
                      <li><a href="/signin#home">Home</a></li>
                      <li><a href="/signin#features">Features</a></li>
                      <li><a href="/signin#about">About</a></li>
                      <li><a href="/signin#why">Why</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-5 col-sm-12">
                <div className="footer-contact mt-50 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.8s">
                  <div className="footer-title"><h4 className="title">Contact Us</h4></div>
                  <ul className="contact">
                    <li>support@wareozo.com</li>
                    <li>www.wareozo.com</li>
                    <li>Nagpur, Maharashtra</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-copyright">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright d-sm-flex justify-content-between">
                  <div className="copyright-content">
                    <p className="text">Designed and Developed by <a href="javascript:void(0)" rel="nofollow"> &nbsp; Wareozo</a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="particles-2"></div>
      </footer>

      <a href="#" className="back-to-top"> <i className="lni lni-chevron-up"> </i> </a>

      <Modal open={open} onClose={(_event: any, reason: any) => {
        if (reason && reason == "backdropClick" && "escapeKeyDown")
          setOpen(false);
      }}>
        <div className='centerme'>
          <div className={`${isMobile ? 'maindiv2' : 'maindiv'}`}>
            <div style={{ width: isMobile ? '100%' : '50%' }}>
              {type === '0' ? <SigninForm setType={setType} /> : type === '1' ? <SignUpForm setType={setType} /> : <ForgotPassword setType={setType} />}
            </div>
            {!isMobile && <div style={{ width: '50%' }}><img src={BgImg2} /></div>}
          </div>
        </div>
      </Modal>
    </>
  );
}

export default OptOutForm;
